import React from "react"
import { Check, Clock3, Mail } from "lucide-react"

export function PasswordRecoveryLayout({ children }) {
  return (
    <main className="auth-layout recovery-layout">
      <section className="auth-story recovery-story">
        <div className="auth-story__content">
          <span className="auth-brand"><img className="brand__mark" src="/brand/baseball-hub-logo.png" alt="" /> Baseball Hub</span>
          <p className="eyebrow eyebrow--light">Account recovery</p>
          <h1>Get back to your team.</h1>
          <p>We’ll help you securely choose a new password and return to your clubhouse.</p>
          <div className="auth-proof recovery-proof">
            <span><Mail size={18} aria-hidden="true" /><span><strong>Check your inbox</strong><small>We send the link to your account email</small></span></span>
            <span><Clock3 size={18} aria-hidden="true" /><span><strong>30-minute link</strong><small>Recovery links expire automatically</small></span></span>
            <span><Check size={18} aria-hidden="true" /><span><strong>One-time use</strong><small>The link closes after your password changes</small></span></span>
          </div>
        </div>
      </section>
      <section className="auth-panel">
        <div className="auth-card recovery-card">{children}</div>
      </section>
    </main>
  )
}
